import type { Job as AtJob, Deal as AtDeal, Company as AtCompany } from '@rogoag/airtable/crm';
import type { IJob, IDeal, ICompany } from '@rogoag/shared-ts';

// Anti-corruption layer: translate Airtable CRM records into the slim DTOs
// the shared-ts lab-CSV generator expects. Pure — no I/O. Keep every field
// optional/undefined-safe; the shared-ts interfaces treat all but `id` as
// optional.

/** Airtable Job -> shared-ts lab-CSV IJob. `id` is the Rogo Job ID so that
 *  non-API jobs render the same "Rogo job id" the legacy CSV did; `apiId`
 *  drives the cloud's `apiId || id` rule for API customers. */
export function toIJob(job: AtJob | undefined): IJob {
  return {
    id: job?.rogoJobId ?? '',
    apiId: job?.apiId,
    name: job?.name,
    sampleDateManOverrideDate: job?.sampleDateManOverrideDate,
    jobFlags: job?.jobFlags,
    eventId: job?.eventId,
    finalLabAccNumber: job?.finalLabAccNumber,
    labInstructions: job?.labInstructions,
    requiredFieldsJobPlusDeal: job?.requiredFieldsJobPlusDeal,
  };
}

/** Airtable Deal -> shared-ts lab-CSV IDeal. `id` MUST equal the deal id the
 *  mission's specs reference (Mission.getDealIdForSpec) so per-spec lookup hits. */
export function toIDeal(deal: AtDeal | undefined): IDeal {
  return {
    id: deal?.id ?? '',
    fieldParameters: deal?.fieldParameters,
    samplingTypeSpecial: deal?.samplingTypeSpecial,
    samplingToleranceFt: deal?.samplingToleranceFt,
    labName: deal?.labName,
    labAddress: deal?.labAddress,
  };
}

/** Airtable Company -> shared-ts lab-CSV ICompany. Only
 *  externalSampleReferenceIdColumn is consumed (by validation). */
export function toICompany(company: AtCompany | undefined): ICompany {
  return {
    id: company?.id ?? '',
    externalSampleReferenceIdColumn: company?.externalSampleReferenceIdColumn,
  };
}
